<template>  
  <div class="blog__categories-wrapper">
    <div class="blog__categories">
      <ul class="blog__categories-links">
        <li v-for="blog in categoryLinks.blogs" :key="blog.blogTitle">
          <a class="blog__categories-link" :href="blog.blogUrl" :class="{ 'blog__categories-link--active' : blog.blogUrl === currentPage }">
            <span class="">{{ blog.blogTitle }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { elementAtTop } from '@/scripts/helpers/elementAtTop.js'

export default {
  name: 'BlogCategoryLinks',
  components: {},
  data () {
    return {
      currentPage: window.location.pathname
    }
  },
  props: {
    categoryLinks: {
      type: Object
    }
  },
  mounted () {
    window.addEventListener('scroll', function (e) {
      elementAtTop('.blog__categories')
    })
  }
}
</script>

<style scoped lang="scss">
  .blog__categories {
    &-links {
      padding: 0;
      margin: 0;
      display: flex;
      position: relative;
      min-width: calc(100% - 18px);

      @include tablet-up {
        width: auto;
        min-width: 0;
      }
      &:after {
        background-color: $color-black-300;
        content: '';
        height: 2px;
        position: absolute;
        bottom: 0;
        width: 100%;
      }
      li {
        padding: 0 12px;
        @include tablet-up {
          padding: 0 20px;
        }
        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }
      }
    }
     &-link {
       position: relative;
       height: 38px;
       text-decoration: none;
       color: $color-green-slate-200;
       display: inline-block;
       font-family: $font-family-primary;
       text-transform: uppercase;
       letter-spacing: 1px;
       font-size: rem(12);
       line-height: rem(20);

       @include tablet-up {
        font-size: rem(14);
        line-height: rem(20);
       }

       &--active {
         color: $color-black-900;
        &:after {
          position: absolute;
          bottom: 0;
          left: 0;
          background-color: $color-black-900;
          content: '';
          height: 2px;
          width: 100%;
          z-index: 2;
        }
       }
     }
  }
</style>
